import React from 'react'
import { forwardRef } from '@grupoboticario/flora-react-system'
import { FloraTypographyProps } from './types'
import { StyledTypography } from './styles'
import { useFloraTypography } from './useFloraTypography'

export const FloraTypography = forwardRef<'p', FloraTypographyProps>(
  (
    {
      'autotagging-flora': autotaggingFlora = 'off',
      'data-flora-text': dataFloraText,
      'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
      viewport = 'desktop',
      fontSize,
      fontWeight = 'regular',
      textDecoration = 'none',
      screenReaderOnly = false,
      children,
      as = 'p',
      ...props
    },
    forwardedRef,
  ) => {
    useFloraTypography(children)
    return (
      <StyledTypography
        {...props}
        ref={forwardedRef}
        data-flora="typography"
        autotagging-flora={autotaggingFlora}
        data-flora-text={dataFloraText}
        data-autotagging-flora-section={dataAutotaggingFloraSection}
        viewport={viewport}
        fontSize={fontSize}
        fontWeight={fontWeight}
        textDecoration={textDecoration}
        as={as}
        aria-label={as === 'span' ? children : undefined}
        screenReaderOnly={screenReaderOnly}
      >
        {children}
      </StyledTypography>
    )
  },
)
